import React, { useEffect } from "react";
import { ToDataSource } from "../logic/BosFileTransfer";
import WidgetImage from "../../components/WidgetImage";

// Externals
import cn from "classnames";

// Component styles
import classes from "./ImageMapWidget.module.scss";

export function ImageMapWidget(props) {
  const { ui, config, data, writeBack } = props;
 
  let widgetId = ui.id;
  //let disabled = ui.readonly || (data && data.readonly);

  let content = data && data.content ? JSON.parse(data.content) : null;
  let valueContentType = content ? content.ContenType : null;
  let valueContent = content ? content.ImageContent : null;
  let imageMode = config ? config.ImageMode : null;
  let imageSize = config ? { width: config.ImageWidth, height: config.ImageHeight } : null;

  useEffect(() => {
    //console.log("ImageMapWidget data of " + ui.id + ": ", data);
  }, [data]);

  const handleDocumentClick = (event) => {
    event.preventDefault();
    //if (disabled) return;
    let x = event.nativeEvent.offsetX;
    let y = event.nativeEvent.offsetY;
    if (imageSize) {
      let clientWidth = event.nativeEvent.target.clientWidth;
      let clientHeight = event.nativeEvent.target.clientHeight;
      let factor = clientWidth/imageSize.width;
      console.log("ImageMap clientWidth, clientHeight, resultingFactor, originalX, originalY", clientWidth, clientHeight, factor, x, y);
      x = (x/factor).toFixed(0);
      y = (y/factor).toFixed(0);
    }
    console.log("ImageMap click on", x, y);
    let value = JSON.stringify({ ClickX: x, ClickY: y });
    writeBack(value, true);
  };

  return (
    <div className={classes.mapWrapper} id={widgetId}>
      <div className={cn(classes.imageWrapper, "dx-texteditor", "dx-editor-outlined")}>
        {valueContent
          ? <WidgetImage className={classes.image} mode={imageMode} src={ToDataSource(valueContent, valueContentType)} onClick={handleDocumentClick} />
          : null
        }
      </div>
    </div>
  );
}